<div class="lang-input-wrapper">
  <!-- ===== bilingual: header with label + tabs ===== -->
  <div class="lang-input-header" *ngIf="bilingual">
    <label class="lang-input-label" *ngIf="label">
      {{ label }} ( {{ activeLang === 'en' ? 'EN' : 'AR' }} )
      <span class="required-star" *ngIf="required">*</span>
    </label>

    <div class="lang-tabs">
      <button type="button" class="lang-tab" [class.active]="activeLang === 'en'" (click)="switchTab('en')">
        English
        <span class="dot" [class.filled]="!!value.en"></span>
      </button>

      <button type="button" class="lang-tab" [class.active]="activeLang === 'ar'" (click)="switchTab('ar')">
        Arabic
        <span class="dot" [class.filled]="!!value.ar"></span>
      </button>
    </div>
  </div>

  <label class="lang-input-label" *ngIf="!bilingual && label">
    {{ label }}
    <span class="required-star" *ngIf="required">*</span>
  </label>

  <!-- ===== bilingual ===== -->
  <ng-container *ngIf="bilingual">
    <textarea *ngIf="type === 'textarea'" class="lang-input-field" [rows]="rows" [dir]="currentDir"
      [placeholder]="currentPlaceholder" [disabled]="disabled" [ngModel]="activeLang === 'en' ? value.en : value.ar"
      (ngModelChange)="onLangInputChange(activeLang, $event)" (keypress)="inputValidation($event)"></textarea>

    <input *ngIf="type !== 'textarea'" [type]="type" class="lang-input-field" [dir]="currentDir"
      [placeholder]="currentPlaceholder" [disabled]="disabled" [ngModel]="activeLang === 'en' ? value.en : value.ar"
      (ngModelChange)="onLangInputChange(activeLang, $event)" (keypress)="inputValidation($event)" />
  </ng-container>

  <!-- ===== single ===== -->
  <ng-container *ngIf="!bilingual">
    <textarea *ngIf="type === 'textarea'" class="lang-input-field" [rows]="rows" [placeholder]="currentPlaceholder"
      [disabled]="disabled" [ngModel]="singleValue" (ngModelChange)="onSingleInputChange($event)"
      (keypress)="inputValidation($event)"></textarea>

    <input *ngIf="type !== 'textarea'" [type]="type" class="lang-input-field" [readonly]="readOnly"
      [placeholder]="currentPlaceholder" [disabled]="disabled" [ngModel]="singleValue"
      (ngModelChange)="onSingleInputChange($event)" (keypress)="inputValidation($event)" />
  </ng-container>
</div>